import i18next, { t } from "i18next";
import { inAppBrowserFunc } from "./inAppBrowser/inAppBrowser";
import { setCurrentWidget } from "../Redux/Reducers/deviceConfigReducer";
import { setGoHome, setRedirectToTabId, setShowLoginModal } from "../Redux/Reducers/appConfigReducer";
import { chatKeys, CLICKED, URL_IFRAME_RENDERER_CATEGORY, URL_RENDERER_CATEGORY } from "../config/Constant";
import { Linking, Platform } from "react-native";
import { sendAnalytics } from "../Redux/Actions/analyticsAction";
import { setRenderFlashMessage, setRenderInfoPopup, setRenderLoader } from "../Redux/Actions/appConfigAction";
import { redirectToDeepLink } from "./deeplink";
import { getRealtimeBookingUrl } from "../Redux/Actions/realtimeBookingAction";
import AsyncStorage from "@react-native-async-storage/async-storage";
import { sendCommand } from "../Redux/Actions/roomControlAction";
import { handleOpenChat } from "../Apps/chat/initializeChat";
import { setRenderWidgetInfoModal } from "../Redux/Actions/appConfigAction";
import { IFRAME_RENDERER } from "../navigation/StackNavigator/routes";
import { fetchOnDemand } from "../Redux/Actions/onDemandAction";


export const nonCompWidgetClick = (widgetData, navigation) => {
    console.log("nonCompWidgetClick------", widgetData);
    
    return async (dispatch, getState) => {
        const { isLoggedIn } = getState().appConfigSlice;
        const { currentGuestDetails } = getState().guestDetailsSlice;
        try {

            if (widgetData.widgetType?.toLowerCase() === "info modal") {
                dispatch(setRenderWidgetInfoModal(true, {
                    widgetHeaderImageUrl: widgetData.widgetHeaderImageUrl,
                    contentTitle: widgetData.contentTitle,
                    contentDescription: widgetData.contentDescription,
                    widgetMetaHtmlId: widgetData.widgetMetaHtmlId,
                }));
                return;
            }


            if(widgetData.widgetType?.toLowerCase() == "ondemand") {
                if (!isLoggedIn) {
                    dispatch(setShowLoginModal(true));
                    return
                }
                dispatch(setRenderLoader(true, "Fetching data..."));
                const { status, data, error } = await dispatch(fetchOnDemand());
                dispatch(setRenderLoader(false));

                if(!status){
                    dispatch(setRenderFlashMessage(false, { type: "danger", message: error }))
                    return
                }

                navigation.navigate(IFRAME_RENDERER, {
                    url: data?.url,
                    iFrameParams: [{
                        queryParam: "xsessiontoken",
                        value: data?.token,
                    }],
                    webViewParams: [{
                        queryParam: 'x-session-token',
                        token: data?.token
                    }]
                });
                return
            }

            if (widgetData.widgetType?.toLowerCase() == "url renderer") {
                dispatch(sendAnalytics(URL_RENDERER_CATEGORY , CLICKED, { element: "widget", platform: Platform.OS, targetUrl: widgetData.targetUrl }))
                inAppBrowserFunc(widgetData.targetUrl);
                return;
            }

            if (widgetData.widgetType?.toLowerCase() == "guest details") {
                dispatch(setShowLoginModal(true));
                return;
            }

            if (widgetData.widgetType?.toLowerCase() === "mur") {
                if (!isLoggedIn) {
                    dispatch(setShowLoginModal(true));
                } else {
                    dispatch(setRenderInfoPopup(
                        true,
                        { 
                            title: widgetData?.widgetTitle || t('room_control.mur.title'), 
                            subtitle: t('room_control.mur.subtitle'), 
                            onContinue: () => { 
                                dispatch(setRenderInfoPopup(false))
                                dispatch(setRenderLoader(true, "Loading..."))
                                dispatch(
                                    sendCommand("murToggleCommand", { interface: 'lutron', action: "murToggleCommand" }, "mur", (status, message) => {
                                        dispatch(setRenderLoader(false))
                                        dispatch(setRenderFlashMessage(true, { type: status ? 'success' : 'danger', message }));
                                    })
                                );
                            }, 
                            primaryBtnLabel: t('room_control.mur.primary_button'), 
                            secondaryBtnLabel: t('room_control.mur.secondary_button')
                        }
                    ))
                }
                return
            }

            if (widgetData.widgetType?.toLowerCase() === "dnd") {
                if (!isLoggedIn) {
                    dispatch(setShowLoginModal(true));
                } else {
                    dispatch(setRenderInfoPopup(
                        true,
                        { 
                            title: widgetData?.widgetTitle || t('room_control.dnd.title'), 
                            subtitle: t('room_control.dnd.subtitle'), 
                            onContinue: () => { 
                                dispatch(setRenderInfoPopup(false))
                                dispatch(setRenderLoader(true, "Loading..."))
                                dispatch(
                                    sendCommand("dndToggleCommand", { interface: 'lutron', action: "dndToggleCommand" }, "dnd", (status, message) => {
                                        dispatch(setRenderLoader(false))
                                        dispatch(setRenderFlashMessage(true, { type: status ? 'success' : 'danger', message }));
                                    })
                                );
                            }, 
                            primaryBtnLabel: t('room_control.dnd.primary_button'), 
                            secondaryBtnLabel: t('room_control.dnd.secondary_button')
                        }
                    ))
                }
                return
            }

            if (widgetData.widgetType?.toLowerCase() === "realtime booking"){
                let room = await AsyncStorage.getItem("room");

                if (!room || room === "null") {
                    inAppBrowserFunc(widgetData.targetUrl)        
                    return;
                }

                dispatch(setRenderLoader(true, "Loading..."))
                dispatch(getRealtimeBookingUrl((status, realTimeResURL) => {
                    if (status) {
                        inAppBrowserFunc(realTimeResURL)
                    } else {
                        inAppBrowserFunc(widgetData.targetUrl)
                        console.log("Error callback from realtime res api : " + realTimeResURL);
                    }
                    dispatch(setRenderLoader(false))
                }))
                return;
            }

            if(widgetData.widgetType?.toLowerCase() === "sms message"){
                const room = await AsyncStorage.getItem('room');
                const number = widgetData.widgetPhone;
                const phoneNumber = number.toString();
                const telLink = `tel:${phoneNumber}`;
                const smsLink = `sms:${phoneNumber}`;

                
                dispatch(setRenderInfoPopup(true, {
                    title: t('smsMessage.heading'),
                    // subtitle: t('smgMessage.sub_heading'),
                    primaryBtnLabel: t('smsMessage.sendButton')?.replace("#NUMBER", phoneNumber),
                    secondaryBtnLabel: t('smsMessage.closeButton'),
                    onContinue: async () => {
                        // let preFilledMsg = '';
                        // if(isLoggedIn){
                        //     await AsyncStorage.setItem("doNotShowSMSPopup", "true");

                        //     preFilledMsg = widgetData.widgetMessageLoggedIn ? 
                        //         currentGuestDetails?.guestProfile?.firstName ? 
                        //             widgetData.widgetMessageLoggedIn.replace("#ROOMNUMBER", room).replace("#GUESTNAME", currentGuestDetails?.guestProfile?.firstName + " " + currentGuestDetails?.guestName).replace("</br>", "\n").replace("<br>", "\n") 
                        //         : widgetData.widgetMessageLoggedIn.replace("#ROOMNUMBER", room).replace("#GUESTNAME", currentGuestDetails?.guestName).replace("</br>", "\n").replace("<br>", "\n") 
                        //     : null
                        // } else {
                        //     preFilledMsg = widgetData?.widgetMessage?.replace("</br>", "\n").replace("<br>", "\n");
                        // }

                        if(Platform.OS === "web"){
                            window.open(telLink, '_self');
                            // const options = {
                            //     replaceLineBreaks: true,
                            //     android: {
                            //         intent: 'INTENT'
                            //     }
                            // };


                            // window?.sms?.send(number.toString(), preFilledMsg, options, () => {},  ()=>{});
                        } else {
                            const supported = await Linking.canOpenURL(telLink);
                            if (supported) {
                                await Linking.openURL(telLink);
                            } else {
                                console.warn("Phone calls not supported on this device");
                                dispatch(setRenderFlashMessage(true, { type: 'danger', message: t('smsMessage.callNotSupported') }));
                                return;
                            }
                            // let checkiOS = /iPad|iPhone|MacIntel|iPod/.test(window?.navigator?.platform);

                            // let smsLink;
                            // if(checkiOS){
                            //     smsLink = `sms:${number.toString()}&body=${encodeURIComponent(preFilledMsg)}`;
                            // } else {
                            //     smsLink = `sms:${number.toString()}?body=${encodeURIComponent(preFilledMsg)}`;
                            // }
                    
                            // window.open(smsLink);
                        }
                        setTimeout(() => {
                            dispatch(setRenderInfoPopup(false));
                            dispatch(setGoHome(true));
                        }, 1000);
                    },
                    onCancel: () => {
                        dispatch(setRenderInfoPopup(false))
                    }
                }));
                return;
            }

            if(widgetData.widgetType?.toLowerCase() === "tab navigation"){
                dispatch(setRedirectToTabId(widgetData.tabsList?.toLowerCase()))
                return
            }


            if(widgetData.widgetType?.toLowerCase() === "tab navigation"){
                dispatch(setRedirectToTabId(widgetData.tabsList?.toLowerCase()))
                return
            }


            dispatch(setRenderInfoPopup(true, { title: i18next.t('featureNotAvailable.heading'), subtitle: i18next.t('featureNotAvailable.sub_heading'), onContinue: () => {redirectToDeepLink(); dispatch(setRenderInfoPopup(false))}, primaryBtnLabel: i18next.t('featureNotAvailable.primary_button'), secondaryBtnLabel: i18next.t('featureNotAvailable.secondary_button')}))
        } catch (error) {
            console.log("error in on click", error);
        }
    }
}